import React from 'react';
import { 
  Users, 
  Award,
  Shield,
  CheckCircle,
  FileText,
  UserCheck,
  Globe,
  Target,
  ClipboardCheck,
  Mail,
  Building2
} from 'lucide-react';

const ComiteDirectivo = () => {
  const directivos = [
    { nombre: 'Francisco Santillán Campos', cargo: 'Director General', pais: 'México' },
    { nombre: 'Norma Alicia Santillán Castillo', cargo: 'Secretario Académico', pais: 'México' },
    { nombre: 'Fabio Nascimbeni', cargo: 'Coordinador de relaciones y asuntos internacionales', pais: 'Bélgica' },
    { nombre: 'Gustavo Toledo Andrade', cargo: 'Coordinador de Difusiones Electrónicas', pais: 'México' },
    { nombre: 'Arturo González Torres', cargo: 'Coordinador de Investigación', pais: 'México' },
    { nombre: 'Ruth Alejandra Santillán Soto', cargo: 'Coordinadora de educación continua y postgrado', pais: 'México' },
    { nombre: 'Orlanda Patricia Santillán Castillo', cargo: 'Coordinadora Editorial', pais: 'México' },
    { nombre: 'Salvador Tinoco', cargo: 'Coordinador diseño tecnológico', pais: 'México' }
  ];

  const vocales = [
    { nombre: 'Dalia Silva Martínez', pais: 'México' },
    { nombre: 'Carlota Leticia Rodríguez', pais: 'México' },
    { nombre: 'Luis Alan Acuña Gamboa', pais: 'México' },
    { nombre: 'Fabio Nascimbeni', pais: 'Bélgica' },
    { nombre: 'Nicolás Hellers', pais: 'Argentina' },
    { nombre: 'Noel Barengo', pais: 'Finlandia' },
    { nombre: 'María Teresa Lugo', pais: 'Argentina' },
    { nombre: 'Juan Fernando Álvarez', pais: 'Costa Rica' },
    { nombre: 'Hugo Molina', pais: 'Paraguay' },
    { nombre: 'Pedro Jurado de Los Santos', pais: 'España' },
    { nombre: 'Isabel Álvarez Casovas', pais: 'España' },
    { nombre: 'Laura Rayón Rumayor', pais: 'España' },
    { nombre: 'Rosa María Pecina Leyva', pais: 'México' },
    { nombre: 'Pedro Iglesias Vázquez', pais: 'España' }
  ];

  const comiteConsultivo = [
    { nombre: 'Georgina Guadalupe Oyervides', pais: 'México' },
    { nombre: 'Nancy Cristina Crespo Bosmediano', pais: 'Ecuador' },
    { nombre: 'Reynaldo Mora Mora', pais: 'Colombia' },
    { nombre: 'Fabio Moya Camacho', pais: 'Colombia' },
    { nombre: 'David Caldevilla Domínguez', pais: 'España' },
    { nombre: 'Carlos Emilio Biscay', pais: 'Argentina' },
    { nombre: 'Emanuele Carisio', pais: 'España' },
    { nombre: 'Nicolás Hellers', pais: 'Argentina' },
    { nombre: 'Noel Barengo', pais: 'Finlandia' },
    { nombre: 'Eilen Oviedo González', pais: 'México' },
    { nombre: 'Marisol Hernández Orellana', pais: 'Chile' },
    { nombre: 'Elba del Rosario Huerta', pais: 'México' },
    { nombre: 'Manuel Pérez Tello', pais: 'México' },
    { nombre: 'Víctor Manuel Sánchez Corrales', pais: 'México' },
    { nombre: 'José Ronaldo Herrera Urbina', pais: 'México' }
  ];

  const comiteAdmision = [
    { nombre: 'Hernán Guillermo Saumett', pais: 'España' },
    { nombre: 'Eva Moreno Sepúlveda', pais: 'México' },
    { nombre: 'Ivonne Romero', pais: 'Colombia' },
    { nombre: 'Roberto Balaguer', pais: 'Uruguay' },
    { nombre: 'Ma. Elena de la Cruz Maldonado', pais: 'México' },
    { nombre: 'Prudencio Rodríguez Dias', pais: 'México' },
    { nombre: 'Benito león Corona', pais: 'México' },
    { nombre: 'Salvador Ponce Ceballos', pais: 'México' },
    { nombre: 'José de Jesús Sandoval Legazpi', pais: 'México' },
    { nombre: 'Grace Benalcazar', pais: 'Ecuador' },
    { nombre: 'Mario Javier Fajardo', pais: 'México' },
    { nombre: 'Alejandra González', pais: 'Venezuela' },
    { nombre: 'Brenda Verónica Grimaldo', pais: 'México' },
    { nombre: 'Isabel López Zamora', pais: 'México' },
    { nombre: 'José Antonio Navarrete Prieto', pais: 'México' },
    { nombre: 'María Porfiria Barrón González', pais: 'México' },
    { nombre: 'Claudia Cintya Peña Estrada', pais: 'México' },
    { nombre: 'Aurora Estrada García', pais: 'México' },
    { nombre: 'Gildardo Linarez Placencia', pais: 'México' },
    { nombre: 'Jorge Vera Jiménez', pais: 'México' },
    { nombre: 'Eva Kasparova', pais: 'Rumania' },
    { nombre: 'Juan Pedro Benitez Guadarrama', pais: 'México' },
    { nombre: 'Luis Alfredo Arguelles Ma', pais: 'México' },
    { nombre: 'Abraham Vega Tapia', pais: 'México' },
    { nombre: 'Román Alberto Quijano García', pais: 'México' },
    { nombre: 'Miguel Ángel Velázquez Ruiz', pais: 'México' },
    { nombre: 'Reyna Isabel Roa Rivera', pais: 'México' },
    { nombre: 'Noemí Rubio Bobadilla', pais: 'México' },
    { nombre: 'Juan José Díaz Perera', pais: 'México' },
    { nombre: 'José Manuel González Freire', pais: 'México' },
    { nombre: 'Rubí Surema Peniche Cetzal', pais: 'México' },
    { nombre: 'Nanci López Martínez', pais: 'México' },
    { nombre: 'Irma Araceli Mendoza Belío', pais: 'México' },
    { nombre: 'Araceli Cuadras Urtuzuástegui', pais: 'México' },
    { nombre: 'César Simini Rosas', pais: 'México' },
    { nombre: 'Hadi Santillana Romero', pais: 'México' },
    { nombre: 'Cristina Aparicio Ávila', pais: 'México' },
    { nombre: 'Rosita Fierros Huerta', pais: 'México' },
    { nombre: 'Lorena Gómez Castañeda', pais: 'México' },
    { nombre: 'Rocky David Mancilla Escobar', pais: 'México' },
    { nombre: 'Nelly Andrade Zamora', pais: 'México' },
    { nombre: 'María Guadalupe Sánchez Gutiérrez', pais: 'México' }
  ];

  const finalidades = [
    {
      numero: '1',
      texto: 'Ofrecer los mejores espacios, recursos y relaciones académicas, estrategias de formación, canales de publicación y distribución posibles para nuestra organización, incluyendo una mayor proyección internacional, con la finalidad de propiciar la interacción entre los miembros de la Red Intercontinental de investigaciones sobre la educación en línea y la calidad cada vez mayor del trabajo académico que realizan.'
    },
    {
      numero: '2',
      texto: 'Establecer principios, criterios y mecanismos que aseguren la calidad equivalente en todos los productos que ofrece y avala el CENID.'
    },
    {
      numero: '3',
      texto: 'Impulsar la incorporación de nuevos socios, con dos criterios: lograr una mayor participación de investigadores por un lado, y lograr un mayor crecimiento y consolidación de la investigación educativa en el ámbito internacional.'
    },
    {
      numero: '4',
      texto: 'Potenciar los servicios que el CENID puede prestar a la educación no convencional por la vía del enorme capital cultural de sus socios y de la diversidad de los productos que pueda generar el comité, con criterios de calidad, eficiencia, distribución equitativa entre los socios y orden en la administración de los mismos.'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <Shield className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Comité Directivo
              </h1>
              <p className="text-xl md:text-2xl text-white/90">
                Estructura organizacional del CENID
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        
        {/* Miembros del Comité Directivo */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Award className="w-8 h-8" />
                Miembros del Comité Directivo
              </h2>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {directivos.map((directivo, index) => (
                  <div 
                    key={index}
                    className="bg-gradient-to-br from-white to-gray-50 p-6 rounded-lg border-2 border-gray-200 hover:border-[#0b742f] hover:shadow-lg transition-all duration-200"
                  >
                    <div className="flex items-start gap-4">
                      <div className="flex-shrink-0">
                        <div className="bg-[#0b742f]/10 p-3 rounded-full">
                          <Building2 className="w-6 h-6 text-[#0b742f]" />
                        </div>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-lg font-bold text-gray-900 mb-1">
                          {directivo.nombre}
                        </h3>
                        <p className="text-[#0b742f] font-semibold mb-2">
                          {directivo.cargo}
                        </p>
                        <p className="text-sm text-gray-600 flex items-center gap-1">
                          <Globe className="w-4 h-4" />
                          {directivo.pais}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Vocales */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Users className="w-8 h-8" />
                Vocales
              </h2>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {vocales.map((vocal, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-2 border-gray-200 hover:border-[#e87729] hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex-shrink-0">
                      <div className="bg-[#e87729]/10 p-2 rounded-full">
                        <UserCheck className="w-5 h-5 text-[#e87729]" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-900 font-medium text-sm">
                        {vocal.nombre}
                      </p>
                      <p className="text-xs text-gray-600">
                        {vocal.pais}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Comité Consultivo */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <ClipboardCheck className="w-8 h-8" />
                Comité Consultivo
              </h2>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {comiteConsultivo.map((miembro, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-2 border-gray-200 hover:border-[#0b742f] hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex-shrink-0">
                      <div className="bg-[#0b742f]/10 p-2 rounded-full">
                        <UserCheck className="w-5 h-5 text-[#0b742f]" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-900 font-medium text-sm">
                        {miembro.nombre}
                      </p>
                      <p className="text-xs text-gray-600">
                        {miembro.pais}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Comité de Admisión */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <FileText className="w-8 h-8" />
                Comité de Admisión
              </h2>
            </div>
            
            <div className="p-8">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {comiteAdmision.map((miembro, index) => (
                  <div 
                    key={index}
                    className="flex items-center gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-2 border-gray-200 hover:border-[#e87729] hover:shadow-md transition-all duration-200"
                  >
                    <div className="flex-shrink-0">
                      <div className="bg-[#e87729]/10 p-2 rounded-full">
                        <UserCheck className="w-5 h-5 text-[#e87729]" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-gray-900 font-medium text-sm">
                        {miembro.nombre}
                      </p>
                      <p className="text-xs text-gray-600">
                        {miembro.pais}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Admisión - Finalidades */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Target className="w-8 h-8" />
                Admisión
              </h2>
            </div>
            
            <div className="p-8">
              <div className="mb-8">
                <p className="text-gray-700 text-lg leading-relaxed">
                  De conformidad con los objetivos del CENID, que se apoyan en trascender académicamente, 
                  influir entre los diferentes actores de la educación en el país, e internacionalmente entre 
                  los maestros y alumnos del sistema educativo, se propone a los miembros el programa de trabajo 
                  con las siguientes finalidades:
                </p>
              </div>

              <div className="space-y-6">
                {finalidades.map((finalidad) => (
                  <div 
                    key={finalidad.numero}
                    className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-l-4 border-[#0b742f] hover:shadow-md transition-shadow duration-200"
                  >
                    <div className="flex gap-4">
                      <div className="flex-shrink-0">
                        <div className="bg-[#0b742f] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold text-lg">
                          {finalidad.numero}
                        </div>
                      </div>
                      <div className="flex-1">
                        <p className="text-gray-700 leading-relaxed">
                          {finalidad.texto}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Reglamento de Admisión */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <FileText className="w-8 h-8" />
                Reglamento de Admisión
              </h2>
            </div>
            
            <div className="p-8">
              {/* De la Operación Interna */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                  <CheckCircle className="w-6 h-6 text-[#e87729]" />
                  De la Operación Interna de la Comisión
                </h3>
                
                <div className="space-y-4">
                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">PRIMERO.</p>
                    <p className="text-gray-700">
                      La Comisión de Admisión (en adelante la Comisión) se reunirá al menos una vez al año.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">SEGUNDO.</p>
                    <p className="text-gray-700">
                      La Comisión evaluará las solicitudes de ingreso al CENID y presentará a la Asamblea 
                      las recomendaciones respectivas basadas en los resultados de dicha evaluación, a fin de 
                      que la Asamblea determine el ingreso de nuevos asociados.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">TERCERO.</p>
                    <p className="text-gray-700">
                      De cada sesión de la Comisión se levantará un acta que consigne la agenda y las 
                      resoluciones de la sesión, así como la lista de las solicitudes evaluadas y los 
                      resultados de la evaluación. Las actas de cada sesión deberán ser firmadas por los 
                      tres miembros de la Comisión. El acta original se enviará al Comité Directivo del 
                      CENID, y una copia se conservará en el archivo de la propia Comisión.
                    </p>
                  </div>
                </div>
              </div>

              {/* Del Mecanismo de Evaluación */}
              <div className="mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                  <ClipboardCheck className="w-6 h-6 text-[#e87729]" />
                  Del Mecanismo de Evaluación de Solicitudes
                </h3>
                
                <div className="space-y-4">
                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-3">PRIMERO. Para ser considerado en la evaluación de la Comisión, se requiere:</p>
                    <ul className="space-y-2 ml-4">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Presentar solicitud de ingreso por escrito</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Presentar el formato curricular con los datos y anexos correspondientes, solicitados en él</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Presentar una carta de postulación extendida por un miembro asociado del CENID</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Toda documentación deberá ser enviada al Comité Directivo, quién la turnará a la Comisión, previo registro en sus archivos</span>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-3">SEGUNDO. Los criterios mínimos establecidos por el procedimiento de evaluación serán los siguientes:</p>
                    <ul className="space-y-2 ml-4">
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Ser investigador en activo en el área educativa</span>
                      </li>
                      <li className="flex items-start gap-2 text-gray-700">
                        <CheckCircle className="w-5 h-5 text-[#e87729] flex-shrink-0 mt-0.5" />
                        <span>Haber sido presentado por algún miembro asociado al CENID</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Del Dictamen */}
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
                  <Shield className="w-6 h-6 text-[#e87729]" />
                  Del Dictamen
                </h3>
                
                <div className="space-y-4">
                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">PRIMERO.</p>
                    <p className="text-gray-700">
                      La Comisión de Admisión presentará al Comité Directivo los dictámenes correspondientes 
                      para ser presentados ante la Asamblea General.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">SEGUNDO.</p>
                    <p className="text-gray-700">
                      El Comité Directivo será responsable de comunicar a los solicitantes el resultado de la evaluación.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">TERCERO.</p>
                    <p className="text-gray-700">
                      Será la Asamblea General la que apruebe en definitiva las admisiones propuestas por la 
                      Comisión de Admisión.
                    </p>
                  </div>

                  <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-[#e87729]">
                    <p className="font-semibold text-[#e87729] mb-2">CUARTO.</p>
                    <p className="text-gray-700">
                      Los dictámenes emitidos por la Comisión de Admisión serán inapelables, pudiéndose solicitar 
                      nuevamente el ingreso en un plazo no menor a un año.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA de Contacto */}
        <section>
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white rounded-lg shadow-xl p-8">
            <div className="text-center max-w-3xl mx-auto">
              <Mail className="w-12 h-12 mx-auto mb-4" />
              <h2 className="text-3xl font-bold mb-4">
                ¿Interesado en formar parte del CENID?
              </h2>
              <p className="text-xl text-white/90 mb-6">
                Si eres investigador en activo en el área educativa y deseas formar parte de nuestra red, 
                contacta a alguno de nuestros miembros para iniciar el proceso de admisión.
              </p>
              <p className="text-lg text-white/80">
                Recuerda que la membresía se adquiere por invitación de alguno de los integrantes actuales.
              </p>
            </div>
          </div>
        </section>

      </div>
    </div>
  );
};

export default ComiteDirectivo;
